import React, { Component } from "react";
import Grid from "@react/react-spectrum/Grid/js/Grid";
import GridColumn from "@react/react-spectrum/Grid/js/GridColumn";
import GridRow from "@react/react-spectrum/Grid/js/GridRow";
import Well from "@react/react-spectrum/Well";
import DataSection from "../../comps/DataSection/DataSection";
import Button from "@react/react-spectrum/Button";
import Heading from "@react/react-spectrum/Heading";
import Checkbox from "@react/react-spectrum/Checkbox";
import Wait from "@react/react-spectrum/Wait";
import { connect } from "react-redux";
import { getFormValues, reduxForm } from "redux-form";
import Rule from "@react/react-spectrum/Rule";
//// import geoPolData from '../../../../registration/config/geoPolData.js';
import throwError, { toastPartnerApiFailure } from "../../comps/errorToast";
import formFields from "../config/formFieldsGovernment";
import Attachment from "../content/Common/Attachment";
import {
  openManageProfile,
  onGovtSubmitClick,
} from "../content/Common/buttonActions";
import Finish from "../content/Common/Finish";
import { answersToFields, createPostBody } from "../utils/api/processor";
import validator from "../../comps/validation";
import dummyResponse from "../utils/api/dummyResponse";
import "../specialization.css";
import { isRestrictedSanctionCountry } from "../../utils/restrictedSanctionCountry";
// TODO(sanctions-ru-by): RU/BY banner + disabled Submit/Choose File — SANCTIONS_RU_BY_VALIDATION_ENABLED
import RestrictedCountryBanner from "../../components/RestrictedCountryBanner";

class Government extends Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    this.state = {
      sectionValidation: { attachment: false },
      formInitialized: false,
      attachment: false,
      isError: false,
      error: {},
      spzContactErrorMsg: null,
    };
    this.emailFields = [
      "qt-34-answer10-0",
      "qt-34-answer10-1",
      "qt-34-answer10-2",
      "qt-34-answer10-3",
      "qt-36-answer11",
      "qt-10-answer10-0",
      "qt-10-answer10-1",
      "qt-10-answer10-2",
    ];
    this.questionWithFollowUp = {
      qt_36_ynu: "section38",
      qt_38_ynu: "section36_0",
      qt_22_ynu: "section35_0",
      qt_23_ynu: "section35_1",
      qt_24_ynu: "section35_2",
    };
    this.additionQuestions = [
      "qt_22_ynu",
      "qt_23_ynu",
      "qt_24_ynu",
      "qt_25_ynu",
      "qt_26_ynu",
      "qt_29_ynu",
      "qt_30_ynu",
      "qt_31_ynu",
    ];
  }

  componentDidMount() {
    this.props.connector.fetchAnswers(
      this.onfetchAnswersComplete,
      this.props.data.partnerInfo.accountId,
      this.props.formName
    );
  }

  fields = {};
  initialFields = {};

  onfetchAnswersComplete = (response) => {
    if (Boolean(response.questionsList)) {
      this.fields = answersToFields(
        response.questionsList,
        response.answers,
        this.props.data
      );
      this.initialFields = { ...this.fields.spzContacts };
      this.props.initialize({
        ...this.fields.initialAnswers,
        ...this.fields.selection,
        ...this.fields.spzContacts,
        accountId: this.props.data.partnerInfo.accountId,
      });
      //this.props.initialize({ ...dummyResponse.values2,"accountId": this.props.data.partnerInfo.accountId});
      this.setState({ formInitialized: true });
    } else {
      this.setState({ isError: true });
    }
  };

  updateValidation = (name, value) => {
    let sectionValidation = this.state.sectionValidation;
    sectionValidation[name] = value;
    Object.keys(this.questionWithFollowUp).map((question) => {
      if (this.props.formStates[question] == "No") {
        delete sectionValidation[this.questionWithFollowUp[question]];
      }
    });
    this.setState({ sectionValidation: sectionValidation });
  };

  isEmailDomain = (val) => {
    return (
      !val.toLowerCase().startsWith("@") &&
      val
        .toLowerCase()
        .endsWith(
          "@" +
            window.adobeIMS.getUserProfile().email.split("@")[1].toLowerCase()
        )
    );
  };

  handleSubmit = () => {
    //this.props.is_saving(true);
    var body;

    //console.log(-1);
    if (Boolean(this.props.isValidated)) {
      //console.log(0);
      let throwMessage = "Please fill out all required fields.";
      let done = false; //checks if catches above error senarios
      let errorTemp = {};
      let spzContactErrorMsg = "";
      Object.keys(this.props.allFields.specialization.registeredFields).map(
        (questionKey) => {
          this.props.touch("specialization", questionKey);
        }
      );

      if (Boolean(this.props.formStates["specializationContact0_email"])) {
        if (
          validator.isEmail(
            this.props.formStates["specializationContact0_email"]
          ) === "invalid"
        ) {
          throwMessage = "Invalid email format.";
          done = true;
          //console.log(1);
        } else if (
          !this.isEmailDomain(
            this.props.formStates["specializationContact0_email"]
          )
        ) {
          //console.log(2);
          errorTemp["emailDomainError"] = true;
          spzContactErrorMsg =
            "The company email domain that you've entered does not match the primary contact's email domain.";
          throwMessage =
            "The company email domain that you've entered does not match the primary contact's email domain.";
          done = true;
        }
      }

      if (
        !done &&
        Boolean(this.props.formStates["specializationContact1_email"])
      ) {
        if (
          validator.isEmail(
            this.props.formStates["specializationContact1_email"]
          ) === "invalid"
        ) {
          //console.log(3);
          throwMessage = "Invalid email format.";
          done = true;
        } else if (
          !this.isEmailDomain(
            this.props.formStates["specializationContact1_email"]
          )
        ) {
          //console.log(4);
          errorTemp["emailDomainError"] = true;
          spzContactErrorMsg =
            "The company email domain that you've entered does not match the primary contact's email domain.";
          throwMessage =
            "The company email domain that you've entered does not match the primary contact's email domain.";
          done = true;
        }
      }

      if (
        !done &&
        Boolean(this.props.formStates["specializationContact0_email"]) &&
        Boolean(this.props.formStates["specializationContact1_email"]) &&
        this.props.formStates["specializationContact0_email"] ===
          this.props.formStates["specializationContact1_email"]
      ) {
        //console.log(5);
        errorTemp["sameEmailError"] = true;
        spzContactErrorMsg =
          "The below contacts must have unique Email address.";
        throwMessage = "There are duplicate emails on the form.";
        done = true;
      }

      if (!done) {
        //console.log(8);
        for (let i = 0; i < this.emailFields.length; i++) {
          if (Boolean(this.props.formStates[this.emailFields[i]])) {
            if (
              validator.isEmail(this.props.formStates[this.emailFields[i]]) ==
              "invalid"
            ) {
              throwMessage = "Invalid email format.";
              break;
            }
          }
        }
      }

      if (!Boolean(this.props.formStates["attachmantName"])) {
        //console.log(6);
        errorTemp["attachment"] = true;
        //throwMessage = "Please attach a file as evidence of promotional history in the Government market.";
      }

      if (!Boolean(this.props.formStates["terms"])) {
        //console.log(7);
        errorTemp["terms"] = true;
        //throwMessage = "Please review the terms and conditions and check where indicated to confirm your acceptance.";
      }

      if (
        !Boolean(this.props.formStates["qt_17_answer4"]) ||
        !Boolean(this.props.formStates["qt_17_answer5"]) ||
        !Boolean(this.props.formStates["qt_17_answer6"])
      ) {
        errorTemp["section40_8Error"] = true;
      }
      if (!Boolean(this.props.formStates["qt_41_radioAnswer"])) {
        errorTemp["qt_41_radioAnswer"] = true;
      }
      if (
        !Boolean(this.props.formStates["qt_36_ynu"]) ||
        !Boolean(this.props.formStates["qt_38_ynu"])
      ) {
        errorTemp["ynu_question"] = true;
      }
      let fieldValueCheck = false;
      for (let i = 0; i < this.additionQuestions.length; i++) {
        fieldValueCheck =
          fieldValueCheck ||
          !Boolean(this.props.formStates[this.additionQuestions[i]]);
        //console.log(fieldValueCheck);
        if (fieldValueCheck) {
          errorTemp["additionQuestions"] = true;
          break;
        }
      }
      //console.log(throwMessage);
      if (Boolean(throwMessage)) {
        throwError(throwMessage);
      }
      this.setState({
        error: errorTemp,
        spzContactErrorMsg: spzContactErrorMsg,
      });
      //this.props.is_saving(false);
    } else {
      this.props.is_saving(true);
      body = createPostBody(
        this.props.formStates,
        this.fields.questionIdMapping,
        this.props.data.partnerInfo.accountId,
        this.initialFields
      );
      if (Boolean(body["select18Error"])) {
        this.setState({ select18Error: true });
        this.props.is_saving(false);
        throwError("Please fill out all required fields.");
      } else {
        //console.log(body);
        this.props.connector.submit(this.splzCallBack, body, this.props);
      }
    }
  };

  splzCallBack = (response) => {
    if (response.saveInProgress === true) {
      setTimeout(
        this.props.connector.statusCheck,
        5000,
        this.splzCallBack,
        response.statusUrl
      );
    } else {
      this.onSubmitComplete(response);
    }
  };

  onSubmitComplete = (response) => {
    this.props.is_saving(false);
    if (!response.saveInProgress && response.accountId) {
      // To show Thank you page
      this.props.onClkFinalSubmit(true);
    } else if ("errorCode" in response || response.isError) {
      toastPartnerApiFailure(response);
    }
  };

  render() {
    if (this.state.isError) {
      return (
        <div>
          <span>We encountered an error.</span>
        </div>
      );
    } else if (this.props.isFinal) {
      return <Finish />;
    } else {
      const formName = "specialization";
      const isSanctionRestricted = isRestrictedSanctionCountry(
        this.props.data?.partnerInfo?.billingCountry,
      );
      this.props.onValidateChange(
        Object.values(this.state.sectionValidation).every(Boolean)
      );
      const RULE = <Rule className="rule" variant="small" />;

      return (
        <div>
          {this.state.formInitialized ? (
            <div>
              <div className="page-head">
                <Heading
                  style={{
                    paddingLeft: "2%",
                    color: "white",
                    fontSize: "22px",
                    fontWeight: "bold",
                  }}
                  variant="pageTitle"
                >
                  GOVERNMENT FORM
                </Heading>
              </div>
              <div className="page-banner">
                <div className="center">
                  <Heading
                    variant="pageTitle"
                    size="28px"
                    style={{ fontWeight: "bold", color: "#323232" }}
                  >
                    Government Specialization Request Form
                  </Heading>
                  <GridRow className="center">
                    <GridColumn size={[12, 6, 6, 6]} offsetSize={[0, 3, 3, 3]}>
                      <Heading
                        variant="subtitle2"
                        style={{ color: "rgb(112, 112, 112)" }}
                      >
                        Thank you for your interest in the Government
                        Specialization. Please review the Government
                        Specialization requirements and the registration
                        criteria below.
                      </Heading>
                    </GridColumn>
                  </GridRow>
                </div>
              </div>
              <Grid>
                <RestrictedCountryBanner visible={isSanctionRestricted} />
                <GridRow>
                  <GridColumn size={[12, 10, 8, 8]} offsetSize={[0, 1, 2, 2]}>
                    <GridRow>
                      <GridColumn>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          Specialization Criteria
                        </Heading>
                      </GridColumn>
                    </GridRow>
                    <Well className="well-white">
                      <GridRow>
                        <GridColumn size={[12, 12, 12, 12]}>
                          <ul className="size15">
                            <li>
                              Reseller must meet all of the criteria for the
                              Government Specialization. See the Adobe Partner
                              Connection Reseller Program Guide for a complete
                              list of requirements.
                            </li>
                            <li>
                              Reseller's ability to meet these criteria in no
                              way obligates Adobe to accept Reseller to the
                              Government Specialization.
                            </li>

                            <li>
                              Reseller must complete this online enrollment.
                            </li>
                            <li>
                              Reseller must accept the Government Specialization
                              terms and conditions.
                            </li>
                          </ul>
                        </GridColumn>
                      </GridRow>
                    </Well>
                    <br />
                    <br />

                    <GridRow>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          Adobe Certified Sales Personnel
                        </Heading>
                        {RULE}
                        <div>
                          <p style={{ margin: "8px 16px" }}>
                            Certified Resellers are required to have a minimum
                            of one(1) Adobe Certified Sales Professional,
                            Government. Gold Resellers are required to have a
                            minimum of two(2) Adobe Certified Sales
                            Professionals, Government. Please enter the contact
                            information of your Adobe Certified Sales
                            Professional/s, Government.
                          </p>
                          {Boolean(this.state.error.emailDomainError) ||
                          Boolean(this.state.error.sameEmailError) ? (
                            <p
                              style={{
                                color: "red",
                                fontStyle: "bold",
                                fontSize: "16px",
                                margin: "8px 16px",
                              }}
                            >
                              Error: {this.state.spzContactErrorMsg}
                            </p>
                          ) : null}
                        </div>
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 6, 6, 6]}>
                        <div style={{ paddingBottom: "2%" }}>
                          <span>Contact 1</span>
                        </div>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section1}
                          sectionName="section1"
                          updateValidation={this.updateValidation}
                        />
                        <br />
                      </GridColumn>
                      <GridColumn size={[12, 6, 6, 6]}>
                        <div style={{ paddingBottom: "2%" }}>
                          <span>Contact 2</span>
                        </div>
                        {this.props.data.partnerInfo.level === "Certified" ? (
                          <DataSection
                            formStates={this.props.formStates}
                            form={formName}
                            field={formFields.section2[1]}
                            sectionName="section2"
                            updateValidation={this.updateValidation}
                          />
                        ) : (
                          <DataSection
                            formStates={this.props.formStates}
                            form={formName}
                            field={formFields.section2[0]}
                            sectionName="section2"
                            updateValidation={this.updateValidation}
                          />
                        )}
                        <br />
                      </GridColumn>
                    </GridRow>
                    <br />

                    <GridRow>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          General Information
                        </Heading>
                        {RULE}
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 6, 6, 6]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section3}
                          sectionName="section3"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                    <br />
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 12, 12, 12]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={[formFields.section40[0]]}
                          sectionName="section40_0"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 2, 2, 2]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section4}
                          sectionName="section4"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 2, 2, 2]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section5}
                          sectionName="section5"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 2, 2, 2]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section6}
                          sectionName="section6"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 2, 2, 2]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section7}
                          sectionName="section7"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                    <br />

                    <GridRow className="margin-row">
                      <GridColumn size={[12, 12, 12, 12]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={[formFields.section40[1]]}
                          sectionName="section40_1"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>

                    <GridRow
                      className="margin-row"
                      style={{ marginTop: "0.9%" }}
                    >
                      <GridColumn
                        size={[12, 3, 2, 2]}
                        style={{ marginRight: "-50px" }}
                      >
                        <br />
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section10}
                          sectionName="section10_0"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 9, 10, 10]}>
                        <GridRow>
                          <GridColumn size={[12, 3, 3, 3]}>
                            <span>CONTACT 1</span>
                            <DataSection
                              formStates={this.props.formStates}
                              form={formName}
                              field={formFields.section8[0]}
                              sectionName="section8_0"
                              updateValidation={this.updateValidation}
                            />
                            <br />
                          </GridColumn>
                          <GridColumn size={[12, 3, 3, 3]}>
                            <span>CONTACT 2</span>
                            <DataSection
                              formStates={this.props.formStates}
                              form={formName}
                              field={formFields.section8[1]}
                              sectionName="section8_1"
                              updateValidation={this.updateValidation}
                            />
                            <br />
                          </GridColumn>
                          <GridColumn size={[12, 3, 3, 3]}>
                            <span>CONTACT 3</span>
                            <DataSection
                              formStates={this.props.formStates}
                              form={formName}
                              field={formFields.section8[2]}
                              sectionName="section8_2"
                              updateValidation={this.updateValidation}
                            />
                            <br />
                          </GridColumn>
                          <GridColumn size={[12, 3, 3, 3]}>
                            <span>CONTACT 4</span>
                            <DataSection
                              formStates={this.props.formStates}
                              form={formName}
                              field={formFields.section8[3]}
                              sectionName="section8_3"
                              updateValidation={this.updateValidation}
                            />
                            <br />
                          </GridColumn>
                        </GridRow>
                      </GridColumn>
                    </GridRow>

                    <GridRow className="margin-row">
                      <GridColumn size={[12, 12, 12, 12]}>
                        {Boolean(this.state.error.ynu_question) ? (
                          <span
                            style={{
                              color: "red",
                              fontStyle: "bold",
                              fontSize: "16px",
                            }}
                          >
                            Error: Please select a value.
                          </span>
                        ) : null}
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={[formFields.section9[0]]}
                          sectionName="section9_0"
                          updateValidation={this.updateValidation}
                        />
                        {this.props.formStates["qt_36_ynu"] === "Yes" ? (
                          <div>
                            <span>
                              If yes, please provide the contact information:
                            </span>
                            <GridRow className="margin-row">
                              <GridColumn
                                size={[12, 3, 2, 2]}
                                style={{ marginRight: "-50px" }}
                              >
                                <DataSection
                                  formStates={this.props.formStates}
                                  form={formName}
                                  field={formFields.section37}
                                  sectionName="section37"
                                  updateValidation={this.updateValidation}
                                />
                              </GridColumn>
                              <GridColumn size={[12, 9, 9, 10]}>
                                <GridRow>
                                  <GridColumn size={[12, 4, 4, 4]}>
                                    <DataSection
                                      formStates={this.props.formStates}
                                      form={formName}
                                      field={formFields.section38}
                                      sectionName="section38"
                                      updateValidation={this.updateValidation}
                                    />
                                    <br />
                                  </GridColumn>
                                </GridRow>
                              </GridColumn>
                            </GridRow>
                          </div>
                        ) : null}
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={[formFields.section9[1]]}
                          sectionName="section9_1"
                          updateValidation={this.updateValidation}
                        />
                        {this.props.formStates["qt_38_ynu"] === "Yes" ? (
                          <DataSection
                            formStates={this.props.formStates}
                            form={formName}
                            field={[formFields.section36[0]]}
                            sectionName="section36_0"
                            updateValidation={this.updateValidation}
                          />
                        ) : null}
                      </GridColumn>
                    </GridRow>
                    <br />
                    <br />

                    <GridRow>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          Organizational structure
                        </Heading>
                        {RULE}
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 6, 6, 6]}>
                        {Boolean(this.state.error.qt_41_radioAnswer) ? (
                          <span
                            style={{
                              color: "red",
                              fontStyle: "bold",
                              fontSize: "16px",
                            }}
                          >
                            Error: Please select a value.
                          </span>
                        ) : null}
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section11}
                          sectionName="section11"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 6, 6, 6]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section12}
                          sectionName="section12"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                    <br />
                    <br />

                    <GridRow>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          Company Classification
                        </Heading>
                        {RULE}
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 12, 12, 12]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={[formFields.section40[2]]}
                          sectionName="section40_2"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 12, 12, 12]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section13}
                          sectionName="section13"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                    <br />
                    <br />

                    <GridRow>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          Government Clearances
                        </Heading>
                        {RULE}
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 12, 12, 12]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section14}
                          sectionName="section14"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                    <br />
                    <br />

                    <GridRow>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          Description of Value-add Solution
                        </Heading>
                        {RULE}
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 12, 12, 12]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section15}
                          sectionName="section15"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                    <br />
                    <GridRow
                      className="margin-row"
                      style={{ marginTop: "0.75%" }}
                    >
                      <GridColumn size={[12, 12, 12, 12]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={[formFields.section40[3]]}
                          sectionName="section40_3"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>

                    <GridRow
                      className="margin-row"
                      style={{ marginTop: "0.50%" }}
                    >
                      <GridColumn
                        size={[12, 3, 2, 2]}
                        style={{ marginRight: "-50px" }}
                      >
                        <br />
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section10}
                          sectionName="section10_1"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 9, 9, 10]}>
                        <GridRow>
                          <GridColumn size={[12, 4, 4, 4]}>
                            <span>Customer reference 1</span>
                            <DataSection
                              formStates={this.props.formStates}
                              form={formName}
                              field={formFields.section41[0]}
                              sectionName="section41_0"
                              updateValidation={this.updateValidation}
                            />
                            <br />
                          </GridColumn>
                          <GridColumn size={[12, 4, 4, 4]}>
                            <span>Customer reference 2</span>
                            <DataSection
                              formStates={this.props.formStates}
                              form={formName}
                              field={formFields.section41[1]}
                              sectionName="section41_1"
                              updateValidation={this.updateValidation}
                            />
                            <br />
                          </GridColumn>
                          <GridColumn size={[12, 4, 4, 4]}>
                            <span>Customer reference 3</span>
                            <DataSection
                              formStates={this.props.formStates}
                              form={formName}
                              field={formFields.section41[2]}
                              sectionName="section41_2"
                              updateValidation={this.updateValidation}
                            />
                            <br />
                          </GridColumn>
                        </GridRow>
                      </GridColumn>
                    </GridRow>
                    <br />

                    <GridRow>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          Revenue Profile
                        </Heading>
                        {RULE}
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 12, 12, 12]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={[formFields.section40[4]]}
                          sectionName="section40_4"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[11, 5, 5, 5]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section16}
                          sectionName="section16"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn
                        size={[1, 1, 1, 1]}
                        style={{ marginLeft: "-8.7%" }}
                      >
                        <div style={{ paddingTop: "6px" }}>
                          <span style={{ color: "rgb(110, 110, 110)" }}>
                            (USD)
                          </span>
                        </div>
                      </GridColumn>
                    </GridRow>
                    <br />
                    <GridRow style={{ margin: "1px", marginBottom: "5px" }}>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={[formFields.section40[5]]}
                          sectionName="section40_5"
                          updateValidation={this.updateValidation}
                        />{" "}
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 3, 3, 3]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section17}
                          sectionName="section17"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 3, 3, 3]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section18}
                          sectionName="section18"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 3, 3, 3]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section19}
                          sectionName="section19"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 3, 3, 3]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section20}
                          sectionName="section20"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                    <br />
                    <GridRow style={{ margin: "1px", marginBottom: "5px" }}>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={[formFields.section40[6]]}
                          sectionName="section40_6"
                          updateValidation={this.updateValidation}
                        />{" "}
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 3, 3, 3]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section21}
                          sectionName="section21"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 3, 3, 3]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section22}
                          sectionName="section22"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 3, 3, 3]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section23}
                          sectionName="section23"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 3, 3, 3]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section24}
                          sectionName="section24"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                    <br />

                    <GridRow>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          Product Information
                        </Heading>
                        {RULE}
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 12, 12, 12]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={[formFields.section40[7]]}
                          sectionName="section40_7"
                          updateValidation={this.updateValidation}
                        />{" "}
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 4, 4, 4]}>
                        <div style={{ paddingTop: "2%", paddingBottom: "2%" }}>
                          <span>Software 1</span>
                        </div>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section25[0]}
                          sectionName="section25_0"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 4, 4, 4]}>
                        <div style={{ paddingTop: "2%", paddingBottom: "2%" }}>
                          <span>Software 2</span>
                        </div>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section25[1]}
                          sectionName="section25_1"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 4, 4, 4]}>
                        <div style={{ paddingTop: "2%", paddingBottom: "2%" }}>
                          <span>Software 3</span>
                        </div>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section25[2]}
                          sectionName="section25_2"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>

                    <GridRow className="margin-row">
                      <GridColumn size={[12, 12, 12, 12]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={[formFields.section40[8]]}
                          sectionName="section40_8"
                          updateValidation={this.updateValidation}
                        />
                        {Boolean(this.state.error.section40_8Error) ? (
                          <span
                            style={{
                              color: "red",
                              fontStyle: "bold",
                              fontSize: "16px",
                            }}
                          >
                            Error: Please select a value.
                          </span>
                        ) : null}
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 4, 4, 4]}>
                        <div style={{ paddingTop: "2%", paddingBottom: "2%" }}>
                          <span>Market 1</span>
                        </div>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section26[0]}
                          sectionName="section26_0"
                          updateValidation={this.updateValidation}
                        />
                        <br />
                      </GridColumn>
                      <GridColumn size={[12, 4, 4, 4]}>
                        <div style={{ paddingTop: "2%", paddingBottom: "2%" }}>
                          <span>Market 2</span>
                        </div>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section26[1]}
                          sectionName="section26_1"
                          updateValidation={this.updateValidation}
                        />
                        <br />
                      </GridColumn>
                      <GridColumn size={[12, 4, 4, 4]}>
                        <div style={{ paddingTop: "2%", paddingBottom: "2%" }}>
                          <span>Market 3</span>
                        </div>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section26[2]}
                          sectionName="section26_2"
                          updateValidation={this.updateValidation}
                        />
                        <br />
                      </GridColumn>
                    </GridRow>
                    <br />

                    <GridRow>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          Government End Users
                        </Heading>
                        {RULE}
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 12, 12, 12]}>
                        {this.state.select18Error ? (
                          <span
                            style={{
                              color: "red",
                              fontStyle: "bold",
                              fontSize: "16px",
                            }}
                          >
                            Error: Please select a value.
                          </span>
                        ) : null}
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={[formFields.section40[9]]}
                          sectionName="section40_9"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 4, 4, 4]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section27}
                          sectionName="section27"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 4, 4, 4]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section28}
                          sectionName="section28"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 4, 4, 4]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section29}
                          sectionName="section29"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                    <br />
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 12, 12, 12]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section30}
                          sectionName="section30"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                    <br />
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 12, 12, 12]}>
                        <span className="size16">
                          If listed at your company website, provide the URL
                          here
                        </span>
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 6, 6, 6]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section31}
                          sectionName="section31"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                    <br />
                    <GridRow>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          Geographic Coverage
                        </Heading>
                        {RULE}
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 12, 12, 12]}>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section32}
                          sectionName="section32"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>
                    <br />

                    <GridRow>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          Additional questions
                        </Heading>
                        {RULE}
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 12, 12, 12]}>
                        {Boolean(this.state.error.additionQuestions) ? (
                          <span
                            style={{
                              color: "red",
                              fontStyle: "bold",
                              fontSize: "16px",
                            }}
                          >
                            Error: Please select a value.
                          </span>
                        ) : null}
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={[formFields.section33[0]]}
                          sectionName="section33_0"
                          updateValidation={this.updateValidation}
                        />
                        {this.props.formStates["qt_22_ynu"] === "Yes" ? (
                          <DataSection
                            formStates={this.props.formStates}
                            form={formName}
                            field={[formFields.section35[0]]}
                            sectionName="section35_0"
                            updateValidation={this.updateValidation}
                          />
                        ) : null}
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={[formFields.section33[1]]}
                          sectionName="section33_1"
                          updateValidation={this.updateValidation}
                        />
                        {this.props.formStates["qt_23_ynu"] === "Yes" ? (
                          <DataSection
                            formStates={this.props.formStates}
                            form={formName}
                            field={[formFields.section35[1]]}
                            sectionName="section35_1"
                            updateValidation={this.updateValidation}
                          />
                        ) : null}
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={[formFields.section33[2]]}
                          sectionName="section33_2"
                          updateValidation={this.updateValidation}
                        />
                        {this.props.formStates["qt_24_ynu"] === "Yes" ? (
                          <DataSection
                            formStates={this.props.formStates}
                            form={formName}
                            field={[formFields.section35[2]]}
                            sectionName="section35_2"
                            updateValidation={this.updateValidation}
                          />
                        ) : null}
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section34}
                          sectionName="section34"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                    </GridRow>

                    <br />
                    <GridRow>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          Attachments
                        </Heading>
                        {RULE}
                      </GridColumn>
                    </GridRow>
                    <GridRow className="margin-row">
                      <GridColumn size={[12, 12, 12, 12]}>
                        {Boolean(this.state.error.attachment) ? (
                          <span
                            style={{
                              color: "red",
                              fontStyle: "bold",
                              fontSize: "16px",
                            }}
                          >
                            Error: Please attach a file as evidence of
                            promotional history in the Government market.
                          </span>
                        ) : null}
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={[formFields.section40[10]]}
                          sectionName="section40_10"
                          updateValidation={this.updateValidation}
                        />
                        <p className="size15" style={{ fontStyle: "italic" }}>
                          Note: You can upload only one attachment. Please
                          combine your items into a single compressed file (such
                          as a ZIP or PDF file).
                        </p>
                      </GridColumn>
                    </GridRow>
                    <Attachment
                      {...this.props}
                      disabled={isSanctionRestricted}
                      updateValidation={this.updateValidation}
                    />

                    <br />
                    <br />
                    <GridRow>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          Terms & Conditions
                        </Heading>
                      </GridColumn>
                    </GridRow>
                    <Well className="well">
                      <GridRow>
                        <GridColumn size={[12, 12, 12, 12]}>
                          {Boolean(this.state.error.terms) ? (
                            <span
                              style={{
                                color: "red",
                                fontStyle: "bold",
                                fontSize: "16px",
                              }}
                            >
                              Error: Please review the terms and conditions and
                              check where indicated to confirm your acceptance.
                            </span>
                          ) : null}
                          <p className="size15">
                            If Reseller’s application for the Government
                            Specialization is accepted by Adobe, the following
                            additional terms shall apply in addition to the
                            Agreement and the Program Guide. Unless otherwise
                            expressly defined in this Addendum, capitalized
                            terms used in this Addendum shall have the same
                            meaning set forth in the Agreement.
                          </p>
                          <p className="size15">
                            1. All information provided by Reseller to Adobe as
                            part of the Government Specialization application is
                            true, correct, complete and accurate in every
                            respect and is not misleading or deceptive
                            (including by omission), and Reseller will update or
                            correct (via email to Adobe at integrity@adobe.com),
                            in a timely manner, any information that it
                            previously submitted that it knows has changed or is
                            no longer true, correct, complete and accurate; and
                          </p>
                          <p className="size15">
                            2. Reseller will abide by the terms of the Agreement
                            and the Partner Connection Program Guide.
                          </p>
                          {/* <DataSection formStates={this.props.formStates} form={formName} field={formFields.section39} sectionName="section39" updateValidation={this.updateValidation} /> */}
                          <GridRow>
                            <GridColumn
                              size={[12, 1, 1, 1]}
                              style={{ marginRight: "-5%" }}
                            >
                              <DataSection
                                formStates={this.props.formStates}
                                form={formName}
                                field={formFields.section39}
                                sectionName="section39"
                                updateValidation={this.updateValidation}
                              />
                            </GridColumn>
                            <GridColumn size={[12, 11, 11, 11]}>
                              <div style={{ paddingTop: "0.5%" }}>
                                <span>
                                  I HAVE READ, UNDERSTOOD, AND AGREED TO COMPLY
                                  WITH THE TERMS AND CONDITIONS INDICATED
                                  HEREIN, AND I REPRESENT AND WARRANT THAT I AM
                                  AUTHORIZED TO BIND THE RESELLER.
                                </span>
                              </div>
                            </GridColumn>
                          </GridRow>
                        </GridColumn>
                      </GridRow>
                    </Well>

                    <br />
                    <br />
                    <GridRow className="margin-row center">
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Button
                          onClick={() => {
                            openManageProfile();
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="cta"
                          disabled={isSanctionRestricted}
                          onClick={() => {
                            this.handleSubmit();
                          }}
                        >
                          Submit
                        </Button>
                      </GridColumn>
                    </GridRow>
                  </GridColumn>
                </GridRow>
              </Grid>
            </div>
          ) : (
            <Wait size="L" centered />
          )}
        </div>
      );
    }
  }
}

Government = reduxForm({
  form: "specialization",
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(Government);

function mapStateToProps(state) {
  return {
    formStates: getFormValues("specialization")(state),
    isValidated: state.specialization.isValidated,
    isFinal: state.specialization.isFinal,
    allFields: state.form,
  };
}

export default connect(mapStateToProps)(Government);
